import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from '@/App.vue'
import router from '@/router'
import i18n from '@/locales'
import { initSentry } from '@/utils/sentry'

import '@/styles/main.css'

const app = createApp(App)

initSentry(app, router)

app.use(createPinia())
app.use(router)
app.use(i18n)

app.mount('#app')
